import { commanServicer } from "../Commen_Services/common.services";
// import axios from "axios";

async function getUserMenu() {

    return await commanServicer.fetchRequest("", true, 'UserMaster/GetUserMenu', 'GET');
}

async function login(loginData: any) {

    return await commanServicer.fetchRequest(JSON.stringify(loginData), false, 'UserMaster/login', 'POST');
}

async function  logOut() {
    return await commanServicer.fetchRequest('', true, 'UserMaster/logout', 'POST');
}

async function tableConfig(pageID: any) {
    return await commanServicer.fetchRequest('', true, 'Report/tblconfig?PageId=' + pageID, 'GET');
}

async function reportConfig(pageID: any) {
    return await commanServicer.fetchRequest('', true, 'Report/reportConfig?PageId=' + pageID, 'GET');
}

async function getDropDownlist(accessKey: any, id: any) {
    if (id != null) {
        return await commanServicer.fetchRequest('', true, 'common/getlist?Sp_Status=' + accessKey+'&id='+id, 'GET');
    }
    else {
        return await commanServicer.fetchRequest('', true, 'common/getlist?Sp_Status=' + accessKey, 'GET');
    }

}

async function  CollectionData(CollectionId:any,SubModeOfPayment:any,CustomerId:any) {
    return await commanServicer.fetchRequest('', true, 'common/getcollectionlist?CollectionId='+CollectionId+'&SubModeOfPayment='+SubModeOfPayment+'&CustomerId='+CustomerId, 'POST');
}



async function getReportlist(pageID: number, fillData: any, paginationData: any) {
    
    
    //{key: 'hqCode', value: 'HQAPANA00001'}]
    const data1 = {
        orderBy: "",
        pageNumber: paginationData !== undefined ? paginationData.pageNumber : 1,
        pageSize: paginationData !== undefined ? paginationData.pageSize : 10,
        isMultiFilter: false,
        pageId: pageID,
        filterArray: fillData,
        isExport: true,

    }
    
    const requestBody = JSON.stringify(data1);
    return await commanServicer.fetchWithAbortReturningController(requestBody, true, 'Report/getreportlist');
}

async function getHistorylist(pageID: number, fillData: any) {
    
    
    //{key: 'hqCode', value: 'HQAPANA00001'}]
    const data1 = {
        orderBy: "",
        pageNumber:  1,
        pageSize: 10,
        isMultiFilter: false,
        pageId: pageID,
        filterArray: fillData,
        isExport: true,

    }

    const requestBody = JSON.stringify(data1);
    return await commanServicer.fetchRequest(requestBody, true, 'Report/gethistory', 'POST');
}

async function historyTableConfig(pageID: any) {
    return await commanServicer.fetchRequest('', true, 'Report/historytblconfig?PageId=' + pageID, 'GET');
}

async function reSynacCollectionAdminToOdoo(collectionID: number) {
    const odooData = {
        collectionId: collectionID
      }
    const requestBody = JSON.stringify(odooData);
    return await commanServicer.fetchRequest(requestBody, true, 'SalesInvoiceDetails/SyncOdooData', 'POST');
}

async function getConsolidateReport(startDate: any, endDate : any) {
    
    
    //{key: 'hqCode', value: 'HQAPANA00001'}]
    const data1 = {
  "start_date": startDate,
  "end_date": endDate
}
    
    const requestBody = JSON.stringify(data1);
    return await commanServicer.fetchRequest(requestBody, true, 'Report/getconsolidatereport');
}

async function getConsolidateReportDetail(rowData: any, subReportKeyField: any) {
    const data1 = {
        "date": rowData?.date,
        "subModeOfPayment": rowData?.subModeOfPayment,
        "consolidateReportDetailType": Number(subReportKeyField)
    }
    const requestBody = JSON.stringify(data1);
    return await commanServicer.fetchWithAbortReturningController(requestBody, true, 'Report/getconsolidatereportdetails');
}

async function getEasebuzzTransactionReport(pageID: number, fillData: any,paginationData: any) {

    const data1 = {
        "pageNumber": paginationData !== undefined ? paginationData.pageNumber : 1,
        "pageSize":  paginationData !== undefined ? paginationData.pageSize : 10,
        "orderBy": "dateOfTransaction DESC",
        "filterArray": fillData,
        "isExport" : paginationData !== undefined ? paginationData.isExport : false
    }    
    const requestBody = JSON.stringify(data1);
    return await commanServicer.fetchWithAbortReturningController(requestBody, true, 'Report/getconsolidateeasebuzzreport');
}





// async function getReportData(pageID : any)
// { const data1 = {
//     orderBy: "",
//     pageNumber: "1",
//     pageSize: "10",
//     isMultiFilter: false,
//     pageId: pageID,
//     filterArray: [],
//     example: ""
//   }
//     const API = axios.create({ baseURL : `http://localhost:1437/api/` });
//     return await   API.POST('Report/getreportlist',data1);
// }

export const userServicer = {
    getUserMenu,
    login,
    tableConfig,
    reportConfig,
    getReportlist,
    getDropDownlist,
    logOut,
    CollectionData,
    getHistorylist,
    historyTableConfig,
    reSynacCollectionAdminToOdoo,
    getConsolidateReport,
    getConsolidateReportDetail,
    getEasebuzzTransactionReport
}